import { useState } from 'react'

/**
 * Navigation component - floating at the top of the page
 */
const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const navigationItems = [
    { name: 'PRESENTING', href: '#presenting' },
    { name: 'MISSION', href: '#mission' },
    { name: 'FEATURES', href: '#features' },
    { name: 'CONTACT US', href: '#contact' },
  ]

  const handleNavClick = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
    setIsMenuOpen(false)
  }

  return (
    <div 
      style={{ 
        position: 'fixed',
        top: 0, 
        left: 0, 
        width: '100%',
        zIndex: 1000,
        margin: 0,
        padding: 0
      }}
    >
      <nav 
        style={{ 
          height: '80px',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)',
          padding: '0 16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          margin: 0,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Centered container to align with site content */}
        <div style={{
          maxWidth: '1280px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px'
        }}>
        {/* Brand/Logo */}
        <a href="#" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
          <img 
            src="/logo.png" 
            alt="KARDS.TECH Logo" 
            className="nav-logo"
            style={{ width: '60px', height: '60px', objectFit: 'contain' }}
          />
          <div className="nav-brand-text">
            <div className="nav-brand-main" style={{ fontSize: '20px', fontWeight: 'bold', lineHeight: '1.2' }}>
              <span style={{ color: 'white' }}>KARDS</span>
              <span style={{ color: '#e5ff47' }}>.TECH</span>
            </div>
            <div 
              className="nav-brand-sub"
              style={{ 
                fontFamily: 'Sequel100-65, sans-serif',
                fontSize: '8px',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                lineHeight: '1'
              }}
            >
              <span style={{ color: '#527c8b' }}>EMPOWERIN</span>
              <span> </span>
              <span style={{ color: '#e5ff47' }}>POKER</span>
              <span> </span>
              <span style={{ color: '#527c8b' }}>LEAGUES</span>
            </div>
          </div>
        </a>
        
          {/* Desktop Navigation */}
          <nav className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: '0' }}>
            {navigationItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                style={{ 
                  color: '#e5ff47', 
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  textDecoration: 'none',
                  padding: '0 16px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  transition: 'color 0.2s'
                }}
                className="nav-link"
              >
                {item.name}
              </a>
            ))}
          </nav>
          
          {/* Mobile menu button */}
          <div 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{ 
              cursor: 'pointer',
              padding: '8px',
              zIndex: 1001
            }}
            className="mobile-menu-btn"
          >
            <img 
              src="/mobile_menu.png" 
              alt="Menu" 
              style={{ 
                display: isMenuOpen ? 'none' : 'block',
                width: '24px',
                height: '24px'
              }}
            />
            <img 
              src="/close-menu.png" 
              alt="Close" 
              style={{ 
                display: isMenuOpen ? 'block' : 'none',
                width: '24px',
                height: '24px'
              }}
            />
          </div>
        </div>
      </nav>
      
      {/* Mobile Navigation Menu */}
      <div 
        className="mobile-nav"
        style={{ 
          backgroundColor: 'rgba(0, 0, 0, 0.95)', 
          padding: '24px 0',
          backdropFilter: 'blur(10px)',
          position: 'fixed',
          top: '80px',
          left: 0,
          width: '100%',
          transform: isMenuOpen ? 'translateY(0)' : 'translateY(-100%)',
          opacity: isMenuOpen ? 1 : 0,
          visibility: isMenuOpen ? 'visible' : 'hidden',
          transition: 'all 0.3s ease-in-out',
          zIndex: 999
        }}
      >
        <div style={{
          maxWidth: '1280px',
          width: '100%',
          padding: '0 24px',
          margin: '0 auto'
        }}>
          {navigationItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.href);
              }}
              style={{ 
                color: '#e5ff47', 
                fontFamily: 'Poppins, sans-serif',
                fontSize: '18px',
                fontWeight: '500',
                textDecoration: 'none',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
                padding: '16px 0',
                borderBottom: '1px solid rgba(229, 255, 71, 0.2)',
                transition: 'color 0.2s'
              }}
              className="mobile-nav-link"
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Navigation
